import React, { useEffect, useState } from 'react';

import Table from '~components/molecules/Table';

import { useAppDispatch, useAppSelector } from '~redux/hooks';

import * as Styles from './_GoldConversionTable.module.scss';
import ViewSerialNoModalModal from '~components/molecules/ViewSerialNoModal';
import ActionButton from '~components/atoms/ActionButton';
import UtilFunctions from '~utils/functions';
import { GoldConversionStatusEnum, MetalTypeEnum } from '~utils/enums';
import Chip from '~components/atoms/Chip';
import combinedActions from '~redux/combinedActions';

const GoldConversionTable = () => {
    const dispatch = useAppDispatch();
    const { Misc: { dateTimeFormat } } = UtilFunctions;

    const goldConversionListing = useAppSelector(state => state.gold.goldConversion.data);

    const goldConversionListingIndex = useAppSelector(state => state.gold.goldConversion.index);
    const isLoading = useAppSelector(state => state.gold.loadings.getGoldConversionListing);
    const isError = useAppSelector(state => state.gold.errors.getGoldConversionListing);

    const [serialNoList, setSerialNoList] = useState<string[]>([]);
    const [isSerialNoModalOpen, setIsSerialNoModalOpen] = useState(false);

    useEffect(() => {
        dispatch(combinedActions.goldGetGoldConversionListingAttempt());
    }, [goldConversionListingIndex]);

    const tableHeader = [
        'TRANSACTION ID',
        'TRANSACTION TYPE',
        'AMOUNT',
        'PRODUCT CONVERTED',
        'SERIAL NUMBER',
        'CUSTOMER NAME',
        'CIF NUMBER',
        'BRANCH CODE',
        'BRANCH NAME',
        'REGION NAME',
        'STATUS',
        'BRANCH TELLER NAME',
        'SALES PERSONNEL NAME',
        'REFERRAL NAME',
        'TRANSACTION DATE',
        'ACTION',
    ];

    const tableBody = goldConversionListing.map(conversion => {
        const {
            conversionId,
            amount,
            targetProductName,
            serialNo,
            customerName,
            CIFNo,
            branchCode,
            branchName,
            regionName,
            status,
            branchTellerName,
            salesPersonnelName,
            referralName,
            createdAt,
            metalType,
        } = conversion;

        const transactionTypeLabel = Number(metalType) === MetalTypeEnum.Silver
            ? 'Silver Conversion'
            : 'Gold Conversion';

        const handleViewSerialNo = () => {
            if (!serialNo) return;

            setIsSerialNoModalOpen(true);
            setSerialNoList(serialNo);
        };

        const renderSerialNo = () => {
            if (!serialNo) return '-';

            return (
                <ActionButton
                    testId='create-conversion-view-serialNo-modal-button'
                    key={conversionId}
                    label='View'
                    onClick={() => handleViewSerialNo()}
                />
            );
        };

        const renderStatusChip = (statusValue: GoldConversionStatusEnum, label: string) => {
            switch (statusValue) {
                case GoldConversionStatusEnum.Pending: {
                    return (
                        <Chip
                            type='warning'
                            label={label}
                        />
                    );
                }

                case GoldConversionStatusEnum.Approved: {
                    return (
                        <Chip
                            type='success'
                            label={label}
                        />
                    );
                }

                case GoldConversionStatusEnum.Rejected: {
                    return (
                        <Chip
                            type='error'
                            label={label}
                        />
                    );
                }

                default: return <Chip label={label} />;
            }
        };

        return {
            className: Number(metalType) === MetalTypeEnum.Gold
                ? Styles['gold-row']
                : '',
            cells: [
                conversionId,
                transactionTypeLabel,
                amount,
                targetProductName,
                renderSerialNo(),
                customerName,
                CIFNo,
                branchCode,
                branchName,
                regionName,
                renderStatusChip(status, GoldConversionStatusEnum[status]),
                branchTellerName || '-',
                salesPersonnelName || '-',
                referralName || '-',
                dateTimeFormat(createdAt),
                '-',
            ],
        };
    });

    return (
        <>
            <Table
                header={tableHeader}
                body={tableBody}
                isLoading={isLoading}
                error={isError}
            />

            <ViewSerialNoModalModal
                isOpen={isSerialNoModalOpen}
                onClose={() => setIsSerialNoModalOpen(false)}
                serialNo={serialNoList}
            />

        </>

    );
};

export default GoldConversionTable;
